import http from "../http-common";

class DashboardDataService {
    GetDashboardData = async() => {
        return http.get("dashboard");
    }
    CreateNextCloudUser() {
        return http.get("dashboard/nextcloud/user/create");
    }
    fetchDeviceRoute(data) {
        return http.get("dashboard/device/route", { params: data });
    }
    getDeviceLocations(data) {
        return http.get("dashboard/device/locations", { params: data });
    }
}

export default new DashboardDataService();